import React, { useState } from 'react';
import ModuleHeader from '../common/ModuleHeader';
import { Package, Coins, Building2 } from 'lucide-react';
import StockList from './StockList';
import StockValorisation from './StockValorisation';
import FournisseursTiers from './FournisseursTiers';

type TabType = 'inventaire' | 'valorisation' | 'fournisseurs';

const StockModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('inventaire');

  const tabs = [
    { id: 'inventaire' as TabType, name: 'Inventaire', icon: Package },
    { id: 'valorisation' as TabType, name: 'Valorisation', icon: Coins },
    { id: 'fournisseurs' as TabType, name: 'Fournisseurs', icon: Building2 },
  ];

  return (
    <div className="w-full space-y-5">
      <ModuleHeader
        title="Stock & Approvisionnement"
        subtitle="Inventaire, valorisation au CMP et suivi fournisseurs"
        icon={Package}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="w-full">
        {activeTab === 'inventaire' && <StockList />}
        {activeTab === 'valorisation' && <StockValorisation />}
        {activeTab === 'fournisseurs' && <FournisseursTiers />}
      </div>
    </div>
  );
};

export default StockModule;
